import { inject, Injectable, OnDestroy } from '@angular/core';

import { WebsocketDispatcherService } from '@senet-uiverse/websockets';
import { Subject, tap } from 'rxjs';

import { EWebsocket } from '../enums';

import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class BillingService implements OnDestroy {
  private readonly wsDispatcher = inject(WebsocketDispatcherService);
  private readonly storageService = inject(StorageService);
  readonly billingUpdateEvent$ = new Subject<void>();

  ngOnDestroy() {
    this.billingUpdateEvent$.next();
    this.billingUpdateEvent$.complete();
  }

  paymentSubscription() {
    return this.bind(EWebsocket.ONLINE_PAYMENT);
  }

  billingSubscriptions() {
    return this.bind(EWebsocket.BILLING_INFO).pipe(
      tap((data: { amount: string; bonus_amount: string }) => {
        const currentProfile = this.storageService.storage().organizationProfile;

        if (data && currentProfile?.active_account) {
          this.storageService.update({
            organizationProfile: {
              ...currentProfile,
              active_account: {
                ...currentProfile.active_account,
                bonus_account_amount: data.bonus_amount,
                account_amount: data.amount,
              },
            },
          });
        }

        this.billingUpdateEvent$.next();
      }),
    );
  }

  private bind(type: Readonly<EWebsocket>, params: Record<string, any> = {}) {
    return this.wsDispatcher.bindToChannel(type, type, {
      ...params,
      token: this.storageService.storage().user?.keycloak_access_token,
    });
  }
}
